import React from 'react';
import AppRoutes from './shared/routes/AppRoutes';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './shared/contexts/auth/AuthContext';
import { AccountProvider } from './shared/contexts/account/AccountContexts';
import { IntercomChat } from './shared/components/intercom/IntercomChat';
import { ThemeProvider } from './shared/contexts/theme/ThemeContext';
import './i18n';
import { Provider } from 'react-redux';
import { store } from './store';

const App = () => {
  return (
    <div className="page">
      <ThemeProvider>
        <Provider store={store}>
          <BrowserRouter>
            <AccountProvider>
              <AuthProvider>
                <AppRoutes />
                <IntercomChat />
              </AuthProvider>
            </AccountProvider>
          </BrowserRouter>
        </Provider>
      </ThemeProvider>
    </div>
  );
};

export default App;
